import { render } from "./minuta-listar.vue?vue&type=template&id=d9799b22"
import script from "./minuta-listar.vue?vue&type=script&lang=js"
export * from "./minuta-listar.vue?vue&type=script&lang=js"

import exportComponent from "/home/econopro-ubuntu/Documents/econopro/fonts/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__